import React from "react";
import { useNavigate, Outlet } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { useAuthMe } from "../auth/useAuthMe";
import AccountDisabledPage from "../pages/AccountDisabledPage";

/**
 * Renders /app content: fetches /auth/me; if enabled === false shows AccountDisabledPage, else Outlet (AppMain or TrackingPage).
 * Must be used inside ProtectedRoute (token is present).
 */
export default function AppGate() {
  const { idToken } = useAuth();
  const { data, loading, error } = useAuthMe(idToken);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (error) {
      navigate("/login", { replace: true });
    }
  }, [error, navigate]);

  if (loading || !data) {
    return (
      <div className="min-h-screen bg-newsprint text-ink flex items-center justify-center">
        <p className="text-ink/80">Loading…</p>
      </div>
    );
  }

  if (!data.enabled) {
    return <AccountDisabledPage />;
  }

  return <Outlet />;
}
